export const createConsumableKeyedBuffer = <K, V>(initial?: [K, Set<V>][]) => {
    const EMPTY_ARRAY: V[] = [];
    const buffer = new Map<K, Set<V>>(initial);
    return Object.freeze({
        push(key: K, value: V) {
            const set = buffer.get(key);
            if (set) {
                set.add(value);
            } else {
                buffer.set(key, new Set([value]));
            }
        },
        consume(key: K) {
            const set = buffer.get(key);
            if (!set || set.size === 0) {
                return EMPTY_ARRAY;
            }
            const result = Array.from(set);
            set.clear();
            return result;
        },
        dump() {
            const result = Array.from(buffer);
            return result;
        },
        has(key: K) {
            return Boolean(buffer.get(key)?.size);
        },
        remove(key: K) {
            buffer.get(key)?.clear();
        },
        clear() {
            buffer.clear();
        },
    });
};
